// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-43d01638] .el-cascader.el-cascader--small {\n  width: 100%;\n}\n[data-v-43d01638] .el-dialog__footer {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
